export default "__VITE_ASSET__C3yyNjFU__"